(ns dre.widgets.geography.events
  (:require
   [dre.fx :as dre.fx]
   [dre.app.countries :as countries]
   [clojure.string :as str]
   [day8.re-frame.tracing :refer-macros [fn-traced]] 
   [dre.i18n.utils :as i18n-utils]
   [dre.network :as-alias network]
   [dre.pages.search.events :as search-events]
   [dre.shared.interface.article.tags :as tags]
   [dre.widgets.analysis.tag-distribution :as tag-distribution-events] 
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

;; extension of analysis/tag_distribution

(def id
  :geography)

;; order distributions by keys :country/..NAME.. and :study-center/..NAME.. for usage in world map
;; mapping of :country and :study-center to map of country code to map of :country-code, :country-tags, :val and :label
;; Some countries from the result set are combined as the d3 worldmap considers them a single country
;; For instance country tags can map to non-unique country-code (i.e. /nld & /nn map to "nld")
(def blacklisted-countries
  #{"CXR" "FRO" ""})

(def tag->ansi3
  {:ae "are"
   :af "afg"
   :ag "dza"
   :aj "aze"
   :al "alb"
   :aland-islands "ala"
   :am "arm"
   :an "and"
   :ao "ago"
   :ar "arg"
   :as "asm"
   :aus "aus"
   :au "aut"
   :aw "abw"
   :bailiwick-of-guernsey "ggy"
   :bb "brb"
   :bc "bwa"
   :be "bel"
   :bermuda "bmu"
   :bg "bgd"
   :bh "bhr"
   :bk "bih"
   :bn "ben"
   :bo "blr"
   :bolivia-plurinational-state-of "bol"
   :br "bra"
   :brunei-darussalam "brn"
   :bs "bhs"
   :bt "btn"
   :bulgaria "bgr"
   :bv "bvt"
   :by "bdi"
   :bz "blz"
   :ca "can"
   :cb "khm"
   :cd "tcd"
   :ce "lka"
   :central-america ""
   :cf "cog"
   :cg "cod"
   :ch "chn"
   :ci "chl"
   :cm "cmr"
   :cn "com"
   :co "col"
   :cr "cri"
   :ct "caf"
   :cu "cub"
   :cv "cpv"
   :cy "cyp"
   :da "dnk"
   :dj "dji"
   :do "dom"
   :ec "ecu"
   :eg "egy"
   :ei "irl"
   :ek "gnq"
   :en "est"
   :er "eri"
   :es "slv"
   :et "eth"
   :ez "cze"
   :falkland-islands-malvinas "flk"
   :federal-republic-of-somalia "som"
   :fg "guf"
   :fj "fji"
   :fm "fsm"
   :fo "fro"
   :fr "fra"
   :french-southern-and-antarctic-lands "atf"
   :ga "gmb"
   :gb "gab"
   :gd "grd"
   :gg "geo"
   :gh "gha"
   :gi "gib"
   :gl "grl"
   :gm "deu"
   :gp "glp"
   :gr "grc"
   :gt "gtm"
   :gu "gum"
   :gv "gin"
   :gy "guy"
   :hk "hkg"
   :hn "hnd"
   :holy-see-vatican-city-state "vat"
   :hr "hrv"
   :ht "hti"
   :hu "hun"
   :ic "isl"
   :id "idn"
   :il "isr"
   :im "imn"
   :in "ind"
   :io "iot"
   :iq "irq"
   :ir "irn"
   :it "ita"
   :iv "civ"
   :ja "jpn"
   :jersey "jre"
   :jm "jam"
   :jo "jor"
   :kazakstan "kaz"
   :ke "ken"
   :kg "kgz"
   :kn "prk"
   :ks "kor"
   :kt "cxr"
   :kw "kwt"
   :ky "cym"
   :lao-people-s-democratic-republic "lao"
   :lb "lbn"
   :lc "lca"
   :lg "lva"
   :lh "ltu"
   :li "lbr"
   :libyan-arab-jamahiriya "lby"
   :lo "svk"
   :ls "lie"
   :lt "lso"
   :lu "lux"
   :ma "mdg"
   :mc "mac"
   :mf "myt"
   :mg "mng"
   :mi "mwi"
   :mk "mkd"
   :ml "mli"
   :mn "mco"
   :mo "mar"
   :moldova-republic-of "mda"
   :montenegro "mne"
   :mp "mus"
   :mq "mtq"
   :mr "mrt"
   :mt "mlt"
   :mv "mdv"
   :mx "mex"
   :my "mys"
   :myanmar "mmr"
   :mz "moz"
   :nc "ncl"
   :ng "ner"
   :ni "nga"
   :nl "nld"
   ;; nn = netherlands antilles
   :nn "nld"
   :no "nor"
   :np "npl"
   :ns "sur"
   :nu "nic"
   :nz "nzl"
   :om "omn"
   :pa "pan"
   :pe "per"
   :pf "pyf"
   :pg "png"
   :pk "pak"
   :pl "pol"
   :po "prt"
   :pr "pri"
   :ps "pse"
   :pu "gnb"
   :pw "plw"
   :py "pry"
   :qa "qat"
   :re "reu"
   :republic-of-finland "fin"
   :ro "rou"
   :rp "phl"
   :russian-federation "rus"
   :rw "rwa"
   :sa "sua"
   :saint-helena-ascension-and-tristan-da-cunha "shn"
   :se "syc"
   :serbia "srb"
   :sf "zaf"
   :sg "sen"
   :si "svn"
   :sj "sjm"
   :sl "sle"
   :sm "smr"
   :sn "sgp"
   :south-georgia-and-the-south-sandwich-islands "sgs"
   :sp "esp"
   :su "sdn"
   :sw "swe"
   :sy "syr"
   :sz "che"
   :tanzania-united-republic-of "tza"
   :th "tha"
   :ti "tjk"
   :tl "tls"
   :to "tgo"
   :tp "stp"
   :ts "tun"
   :tt "tto"
   :tu "tur"
   :tw "twn"
   :tx "tkm"
   :ug "uga"
   :uk "gbr"
   :um "umi"
   :up "ukr"
   :us "usa"
   :uv "bfa"
   :uy "ury"
   :uz "uzb"
   :venezuela-bolivian-republic-of "ven"
   :vi "vir"
   :vm "vnm"
   :vu "vut"
   :wa "nam"
   :wi "esh"
   :wz "swz"
   :xk "xks"
   :ye "yem"
   :za "zmb"
   :zi "zwe"})

(def code->name countries/code->name)

(defn organise-world-results
  [distribution]
  (let [distribution
        (-> distribution
            ;; empty keyword breaks (namespace kw)
            (dissoc (keyword "")))

        ;; type is :country or :study-center
        by-type
        (fn [type distribution]
          (let [;;distribution has :country/us, :study-center/nl etc.
                countries (into {}
                                (filter (fn [[k _ :as entry]]
                                          (when (= (namespace k) type)
                                            entry)))
                                distribution)

                ;; country tags can map to non-unique country-code (i.e. /nld & /nn map to "nld")
                countries-with-codes-by-code
                (reduce
                 (fn [acc [country-tag val]]
                   (let [;; nl -> NLD, us -> USA etc
                         country-code (str/upper-case
                                       (get tag->ansi3
                                            (keyword (name country-tag))
                                            (name country-tag)))]
                     (cond
                       (contains? blacklisted-countries country-code)
                       acc

                       (contains? acc country-code)
                       (update acc country-code
                               (fn [old]
                                 (-> old
                                     (update :country-tags conj country-tag)
                                     (update :val + val))))

                       :else
                       (assoc acc country-code
                              {;; [:country/us :country/..tag for same..]
                               :country-tags [country-tag]
                               ;; result count
                               :val val
                               ;; USA
                               :country-code country-code
                               ;; United States of America
                               :label (code->name country-code)}))))
                 {}
                 countries)]
            countries-with-codes-by-code))]
    {:mentions (by-type "country" distribution)
     :affiliations (by-type "aff-country" distribution)
     :study-center (by-type "study-center" distribution)}))

(defn ->country-pill
  ([term type]
   (let [{:keys [:label :country-code :term]} term
         code (or country-code term)
         sense (when code
                 (first
                  (tags/inverse-country-sense-map
                   (keyword "country" code))))]
     (case type
       :mentions
       {:pill/type :term
        :pill/category :country
        :pill/query sense
        :pill/label label}
       :study-center
       {:pill/pill {:pill/type :term
                    :pill/category :country
                    :pill/query sense
                    :pill/label label}
        :pill/query "study-center"
        :pill/type :sentence-tag}
       :affiliations
       {:pill/pill {:pill/type :term
                    :pill/category :country
                    :pill/query sense
                    :pill/label label}
        :pill/query "affiliation"
        :pill/type :sentence-tag}))))

;; -- Events

(rf/reg-event-fx
 ::export
 [rf/trim-v]
 (fn-traced
  [{root-db :db} [type]]
  (let [db (get-in root-db tag-distribution-events/db-path)
        i18n-db (:i18n root-db)
        data (get-in db [:data id])
        countries (organise-world-results data)
        data (get countries type)
        data (sort-by :val > (vals data))
        header (str "\"" (i18n-utils/translate i18n-db "Country") "\",\"" (i18n-utils/translate i18n-db "count") "\"")
        data (str/join "\n" (for [d data]
                              (str (pr-str (:label d)) "," (:val d))))
        csv (str header "\n" data)]
    (rf/dispatch [::dre.fx/download {:content csv
                                     :filename (str "geography-" (name type) ".csv")
                                     :mimetype "text/csv"}])
    nil)))

;; -- Subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db tag-distribution-events/db-path)))


(rf/reg-sub
  ::status
  :<- [::state]
  (fn [db _]
    (:state db)))


(rf/reg-sub
 ::data
 :<- [::state]
  :<- [::search-events/widget-filters]
 (fn [[db filters] [_ type]]
   (let [worldmap-filter-key :geography
         f (get filters worldmap-filter-key)
         data (get-in db [:data id])
         countries (organise-world-results data)]
     (when-let [country-distribution (get countries type)]
       (let [click (fn [term] #(rf/dispatch [::search-events/widget-filter-select
                                             worldmap-filter-key
                                             (->country-pill term type)]))
             tf (fn [e]
                  (let [f? (contains? f (->country-pill e type))]
                    {:term (:country-code e)
                     :label (:label e)
                     :type type
                     :class (keep identity [(when (seq f) (if f? "active" "inactive"))])
                     :on-click (click e)
                     :val (:val e)
                     :count (:val e)}))
             top-countries (->> country-distribution
                                vals
                                (sort-by :val >))
             top-countries (filter #(and (:label %) (> (:val %) 0)) top-countries)
             top-countries (map tf top-countries)
             count-by-codes (into {} (map (fn [c] [(:term c) c])) top-countries)]
         {:top-countries top-countries
          :count-by-codes count-by-codes})))))

;; 
(defn- country-pill?
  [{:pill/keys [category pill]}]
  (or (= category :country) (= (:pill/category pill) :country)))

(defn country-filters
  [db]
  (->> db
       search-events/db-path
       :widget-filters
       id
       (filter country-pill?)))

(defn country-queries
  [db]
  (->> db
       search-events/db-path
       :search-query
       :query/pills
       (filter country-pill?)))

(defn selected-geography?
  [db]
  (let [x (concat (country-filters db) (country-queries db))]
    (not-empty x)))

(rf/reg-sub
 ::used-in-search?
 selected-geography?)


